<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    class="icon-svg icon-facebook"
  >
    <g
      fill-rule="evenodd"
      class="fill"
    >
      <path
        class="fill"
        d="M20.355 30.567H29.1c.808 0 1.467-.659 1.467-1.467V2.9c0-.81-.659-1.467-1.467-1.467H2.9c-.81 0-1.467.657-1.467 1.467v26.2c0 .808.657 1.467 1.467 1.467h11.655V20.355H12.36c-.395 0-.716-.32-.716-.716v-4.367c0-.396.321-.717.716-.717h2.195V12.36c0-3.605 2.933-6.538 6.54-6.538h4.366c.396 0 .717.321.717.717v4.366c0 .396-.32.717-.717.717h-4.367c-.408 0-.739.331-.739.738v2.195h5.106c.211 0 .411.093.547.254.136.16.195.373.16.581l-.728 4.366c-.058.346-.357.6-.707.6h-4.378v10.211zM29.1 32h-9.46c-.397 0-.718-.32-.718-.717V19.64c0-.396.321-.717.717-.717h4.487l.49-2.934h-4.977c-.396 0-.717-.32-.717-.716V12.36c0-1.197.974-2.17 2.172-2.17h3.651V7.254h-3.65c-2.817 0-5.107 2.29-5.107 5.105v2.912c0 .395-.32.716-.716.716h-2.195v2.934h2.195c.395 0 .716.321.716.717v11.644c0 .396-.32.717-.716.717H2.9C1.3 32 0 30.698 0 29.1V2.9C0 1.3 1.3 0 2.9 0h26.2C30.698 0 32 1.3 32 2.9v26.2c0 1.598-1.302 2.9-2.9 2.9z"
      />
    </g>
  </svg>
</template>
